import React, {  Component } from 'react';
import { connect } from 'react-redux';

class AddCustomerServiceNotesForADCTruckloadOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			notes: '',
			errorMessage: '',
			defaultNote: 'ADC Truckload less than 26 points.  Notes: '
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('AddCustomerServiceNotesForADCTruckloadOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
			notes: this.props.customerServiceNotes.replace(this.state.defaultNote, ''),
            showDialog: this.props.showDialog
        });
	}
	setNotes(event) {
		event.preventDefault();
		var value = event.target.value;
		if(value.length > 187) {
			value = value.substring(0, 187);
			event.target.value = value;
		}
		this.setState({
			notes: value
		})
	}
	handleAddNotesForADCTruckLoad() {
		const { notes, defaultNote } = this.state;
		this.setState({
			errorMessage: ''
		})
		if(notes) {
			this.props.handleAddNotesForADCTruckLoad(`${defaultNote} ${notes}`);
		} else {
			this.setState({
				errorMessage: 'Please enter valid notes.'
			})
		}
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="AddCustomerServiceNotesForADCTruckloadOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Add Order Notes For Customer Service Review</h2>
                    <textarea
						id="addCustomerServiceNotesTextfield"
						name="addCustomerServiceNotesTextfield"
						className="customer-notes"
						onChange={this.setNotes.bind(this)}
						defaultValue={this.state.notes}
					/>
                    <div className="noButtonContainer">
                      	<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                      	<a className="yesButton blueButton" onClick={this.handleAddNotesForADCTruckLoad.bind(this)}>Add Notes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

AddCustomerServiceNotesForADCTruckloadOverlayDialog = connect(mapStateToProps)(AddCustomerServiceNotesForADCTruckloadOverlayDialog);
export default AddCustomerServiceNotesForADCTruckloadOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addCustomerServiceNotesForADCTruckloadOverlayDialog.js